import Vue from 'vue';
import router from '@/router';
import store from '@/store/store';
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import {
    log,
} from '@/js/function';
import sys from '@/js/variable';

Vue.use(BootstrapVue);

// load component
Vue.component('com-loading', require('@/components/com-loading.vue'));
Vue.component('com-modal', require('@/components/com-modal.vue'));

firebase.initializeApp(sys.firebaseConfig);


// add custom attribute
Vue.directive('focus', {
    inserted(el) {
        el.focus();
    },
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
});

// ga
(function(i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function() {
        (i[r].q = i[r].q || []).push(arguments)
    }, i[r].l = 1 * new Date();
    a = s.createElement(o),
        m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m)
})(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

ga('create', 'UA-63053452-15', 'auto');
ga('send', 'pageview');



// WEBPACK FOOTER //
// ./src/main.js